import { useMemo } from 'react';
import { useRouter } from 'next/router';
import Product from '@/creditflowresearch/domain/Product';
import Region from '@/creditflowresearch/domain/Region';
import Market from '@/creditflowresearch/domain/Market';
import Segment from '@/creditflowresearch/domain/Segment';
import {
  ICorporateTopFilterPayload,
} from '@/creditflowresearch/application/TopCompanies/corporateTopCompanies/interfaces';

interface IUseCorporateFiltersProps {
  serverFilters: ICorporateTopFilterPayload,
}

const useCorporateTopCompanyFilters = ({ serverFilters }: IUseCorporateFiltersProps): ICorporateTopFilterPayload => {
  const { query } = useRouter();

  return useMemo(() => ({
    ...serverFilters,
    includedProductIds: Product.getIds(query.products),
    includedRegionIds: Region.getIds(query.regions),
    includedMarketIds: Market.getIds(query.markets),
    includedSegmentIds: Segment.getIds(query.segments),
  }), [query, serverFilters]);
};

export default useCorporateTopCompanyFilters;
